<template>
  <div>
    <div class="columns">
      <div v-if="journey.vehicleInfo.photo != 'https://none'" class="column is-3">
        <img width="60" :src="journey.locationInfo.logo" />
      </div>
      <div v-else class="column is-2">
          <b-icon icon="car"></b-icon>
      </div>
      <div class="column">
        <h4 class="is-size-6 has-text-weight-bold">{{ journey.companyInfo.name}}</h4>
        <p class="is-size-6 has-text-grey-light">{{ journey.pickupInfo.dateTime.date | formatDate}} - {{ journey.dropoffInfo.dateTime.date | formatDate}}</p>
        <div class="is-size-7">{{ (journey.vehicleInfo.displayName) }}</div>
        <OutOfPolicyTag v-if="journey.travelPolicy" class="" :travelPolicy="journey.travelPolicy"></OutOfPolicyTag>
        <a v-if="!display_full" @click="display_full = !display_full" class="gant-text is-size-7">Show details</a>
        <a v-else @click="display_full = !display_full" class="is-size-7">Hide details</a>
      </div>
    </div>
    <div v-if="display_full" class="columns" style="padding-top: 10px;">
      <div class="column is-narrow">
        <img width="120" style="margin: auto;" :src="journey.vehicleInfo.photo">

      </div>
      <div class="column">
        <span class="is-size-6 has-text-grey-light">{{journey.vehicleInfo.model}}</span><br />
        <!--<span style="font-size: 10px; padding-top: 5px; margin-right: -5px;"> <a @click="goToMaps(journey.locationInfo.position.lat , journey.locationInfo.position.lng)"> {{ journey.locationInfo.address }}</a> </span> <b-icon icon="map-marker"></b-icon><br />-->
        <b-tag style="margin:0rem 1rem 1rem 0rem; border:0rem; font-size: 1rem;">
          <span >  {{  journey.vehicleInfo.passengers  }}</span><b-icon size="is-small" icon="account"></b-icon>
        </b-tag>
        <b-tag style="margin:1rem 1rem 0rem 0rem; border:0rem; font-size: 1rem;">
          <span>  {{  journey.vehicleInfo.doors  }}</span><b-icon size="is-small" icon="car-door"></b-icon>
        </b-tag>

        <div class="columns is-gapless">
            <div class="column">
              <RentalLocationSummary :location="journey.pickupLocation" :occursAt="journey.pickupInfo.dateTime" rentalEndpoint="Pick-Up"></RentalLocationSummary>
            </div>
            <!--<div class="column is-narrow has-text-grey-lighter">
              <b-icon :icon="rentalTypeIcon" class="mx-4 mt-5" size="is-medium"></b-icon>
            </div>-->
            <div class="column">
              <RentalLocationSummary :location="journey.dropoffLocation" :occursAt="journey.dropoffInfo.dateTime" rentalEndpoint="Drop-Off"></RentalLocationSummary>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import GMap from '../GMap/GMap.vue'
  import OutOfPolicyTag from '../Tags/OutOfPolicyTag.vue'
  import RentalLocationSummary from '../BookTravel/Car/RentalLocationSummary.vue'

  export default {
    name: 'SmallCarItinerary',
    props: {
        journey: Object,
        puLocation: Object,
        doLocation: Object
      },
    components: {
        OutOfPolicyTag,
        RentalLocationSummary

      },
    data: function () {
          return {
            display_full: false,
        }
      },
    methods: {
                goToMaps(lat, long) {
                  // console.log('tried')
                  var details = {
                      parent: this,
                      component: GMap,
                      props: {
                        "lat": lat,
                        "long": long,
                        "width": '700',
                        "height": '600',
                        'image': this.journey.locationInfo.logo,
                        'carOrHotel': 'car'
                    },
                      hasModalCard: true,
                      trapFocus: true,
                      width: 700
                  }
                    this.$buefy.modal.open(details)
                  }
            },
  }
</script>

<style scoped>
</style>
